import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideZonelessChangeDetection, type ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '@env';
import { getAuthProviders, provideEnv } from '@evc/platform';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideEnv(environment),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes),
    ...getAuthProviders(environment),
  ],
};
